/**
 * UX-020: tab-model facts shared by the project strip and the Claims lens.
 * Kept out of ProjectView.tsx so that file keeps exporting components only.
 */

/**
 * ONE label set for both tab strips. The project strip and the Claims lens used
 * to name the same tabs twice ("AI Analysis" / "Assessment", "Prior Art &
 * Research" / "Prior art", "Next Steps" / "What Next"), which made the same
 * content look like different data. Both now read from here.
 */
export const TAB_LABELS = {
  'ai-analysis': 'AI Analysis',
  research: 'Prior Art & Research',
  'next-steps': 'Next Steps',
} as const

/** Review is a primary tab while its stage is active or still ahead; behind More once complete. */
export function reviewTabIsPrimary(status: 'completed' | 'active' | 'pending' | 'locked' | undefined): boolean {
  return status === 'active' || status === 'pending'
}
